export default {
  path: 'class/file/preview/:fileId/:vid',
  component: resolve => require(['../../../pages/user/classfile'], resolve),
  props: true
}



// WEBPACK FOOTER //
// ./src/router/user/classfile/index.js